import React from 'react';
import PropTypes from 'prop-types';

const AppIcon = ({ src, alt, className, style }) => {
    return (
        <img
            src={src}
            alt={alt}
            className={className}
            style={style}
        />
    );
};

AppIcon.propTypes = {
    src: PropTypes.string.isRequired, // SVG file path
    alt: PropTypes.string, // Alt text for accessibility
    className: PropTypes.string, // Optional CSS class name
    style: PropTypes.object, // Optional inline styles
};

export default AppIcon;